export default {
  taxExcludedAmount: {
    id: 'bo_seller.insights.financial_report.tax_excluded_amount',
    defaultMessage: 'Amount (tax\u00A0excl.)',
  },
  vat: {
    id: 'bo_seller.insights.financial_report.vat',
    defaultMessage: 'VAT',
  },
  taxIncludedAmount: {
    id: 'bo_seller.insights.financial_report.tax_included_amount',
    defaultMessage: 'Amount (tax\u00A0incl.)',
  },
}
